import Vue from 'vue';
import VueRouter from 'vue-router';
// import store from './store'
import VueCookies from 'vue-cookies';
import utils from './config/utils.js';
import services from './config/services.js';

import HomeIndex from './Index.vue';
import User from './pages/user/User.vue';
import StudyRecord from './pages/user/model/StudyRecord.vue';
import MyClass from './pages/user/model/MyClass.vue';
import myPractice from './pages/user/model/myPractice.vue';
import myNote from './pages/user/model/myNote.vue';
import AgainPractice from './pages/user/model/AgainPractice.vue';
import NowPractice from './pages/user/model/NowPractice.vue';
import myAssess from './pages/user/model/myAssess.vue';
import assessAnswer from './pages/user/model/assessAnswer.vue';
import againAssess from './pages/user/model/againAssess.vue';
import endAssess from './pages/user/model/assessEnd.vue';
import Class from './pages/class/Class.vue';
import Class404 from './pages/class/Class404.vue';
import ClassDetail from './pages/class/ClassDetail.vue';

import ClassVideo from './pages/class/ClassVideo.vue';
import Page404 from './components/Page404.vue';
import myCertificate from './pages/user/model/myCertificate.vue';
import Study from './pages/study/index.vue';
import myStudy from './pages/user/model/myStudy.vue';
import HzvtcIndex from '@/pages/hzvtc/index.vue';
import HzvtcListCulture from '@/pages/hzvtc/list/culture.vue';
import HzvtcListProfession from '@/pages/hzvtc/list/profession.vue';
import HzvtcListValue from '@/pages/hzvtc/list/value.vue';
import HzvtcListFeelings from '@/pages/hzvtc/list/feelings.vue';
import HzvtcListFeature from '@/pages/hzvtc/list/feature.vue';
import HzvtcListhzdx from '@/pages/hzvtc/list/hzdx.vue';
import HzvtcListVita from '@/pages/hzvtc/list/vita.vue';
import HzvtcDetail from '@/pages/hzvtc/detail.vue';
import HzvtcnewDetail from '@/pages/hzvtc/list/newDetail.vue';
import HzvtcSearch from '@/pages/hzvtc/search.vue';
import HzvtcZyqsz from '@/pages/hzvtc/list/zyqsz.vue';
import HzvtcArticle from '@/pages/hzvtc/article.vue';

import PartyIndex from '@/pages/custom/party/index.vue';
import PartyJoin from '@/pages/custom/party/list/join.vue';
import PartyEdu from '@/pages/custom/party/list/edu.vue';
import PartyNew from '@/pages/custom/party/list/new.vue';
import PartyLearn from '@/pages/custom/party/list/learn.vue';
import PartyExample from '@/pages/custom/party/list/example.vue';
import PartyLocal from '@/pages/custom/party/list/local.vue';
import PartySearch from '@/pages/custom/party/search.vue';
import PartyDetail from '@/pages/custom/party/detail.vue';
import PartyProject from '@/pages/custom/party/project.vue';

import clnyy from '@/pages/custom/clnyy/index.vue';
import sxyxlx from '@/pages/custom/sxyxlx/index.vue';

// 杭科数字地图网络评审页面 - 100060
import BaseDetail from '@/pages/hangke/baseDetail.vue';
import BaseVideo from '@/pages/hangke/baseVideo.vue';
import BaseList from '@/pages/hangke/baseList.vue';
// 黑龙江农业经济职业学院
import hljindex from '@/pages/custom/hlj/index.vue';
import pxztList from '@/pages/custom/hlj/list/pxzt_list.vue';
import jjfzList from '@/pages/custom/hlj/list/jjfz_list.vue';
import hljDetail from '@/pages/custom/hlj/detail.vue';

import qinghai from '@/pages/custom/qinghai/index.vue';

Vue.use(VueRouter);
var staticRoutes = [
    {
        path: '/:schoolcode(\\d+)',
        redirect: '/:schoolcode(\\d+)/user/myClass',
    },
    {
        path: '/:schoolcode(\\d+)/user',
        name: '个人中心',
        component: User,
        children: [
            {
                path: 'studyRecord',
                name: '学习记录',
                component: StudyRecord,
            },
            {
                path: 'myClass',
                name: '我的课程',
                component: MyClass,
            },
            {
                path: 'center',
                redirect: '/:schoolcode(\\d+)/user/myClass',
            },
            {
                path: 'userMessage',
                redirect: '/:schoolcode(\\d+)/user/myClass',
            },
            {
                path: 'userMessage/modifyPhone',
                redirect: '/:schoolcode(\\d+)/user/myClass',
            },
            {
                path: 'userMessage/bindPhone',
                redirect: '/:schoolcode(\\d+)/user/myClass',
            },
            {
                path: 'userMessage/modifyEmail',
                redirect: '/:schoolcode(\\d+)/user/myClass',
            },
            {
                path: 'updatePassword',
                redirect: '/:schoolcode(\\d+)/user/myClass',
            },
            {
                path: 'myPractice',
                name: '我的练习',
                component: myPractice,
            },
            {
                path: 'myAssess',
                name: '我的测评',
                component: myAssess,
            },
            {
                path: 'myNote',
                name: '我的笔记',
                component: myNote,
            },
            {
                path: 'myCertificate',
                name: '我的证书',
                component: myCertificate,
            },
            {
                path: 'myStudy',
                name: '我的数据',
                component: myStudy,
            },

            // myStudy
        ],
    },
    {
        path: '/:schoolcode(\\d+)/class/:classId/',
        component: HomeIndex,
        children: [
            // {
            //   path: '/:schoolcode(\\d+)/class',
            //   name: '课程资源',
            //   component: Class
            // },
            {
                path: '/:schoolcode(\\d+)/class/:classId/',
                name: '课程查看',
                component: ClassDetail,
            },
        ],
    },

    {
        path: '/:schoolcode(\\d+)/nologin/class/:classId/',
        component: HomeIndex,
        children: [
            // {
            //   path: '/:schoolcode(\\d+)/class',
            //   name: '课程资源',
            //   component: Class
            // },
            {
                path: '/:schoolcode(\\d+)/nologin/class/:classId/',
                name: '课程查看',
                component: ClassDetail,
            },
        ],
    },
    {
        path: '/:schoolcode(\\d+)/video/:classId/:videoId',
        name: '课程播放',
        component: ClassVideo,
    },
    {
        path: '/:schoolcode(\\d+)/class/notfound',
        name: 'Class404',
        component: Class404,
    },
    {
        path: '/:schoolcode(\\d+)/Error',
        name: 'Error',
        component: Error,
    },

    {
        path: '/:schoolcode(\\d+)/user/myPractice/AgainPractice',
        name: '我的练习-再次答题',
        component: AgainPractice,
    },
    {
        path: '/:schoolcode(\\d+)/user/myPractice/NowPractice',
        name: '我的练习-立即答题',
        component: NowPractice,
    },
    {
        path: '/:schoolcode(\\d+)/user/myAssess/assessAnswer',
        name: '我的测评-测评答题',
        component: assessAnswer,
    },
    {
        path: '/:schoolcode(\\d+)/user/myAssess/againAssess',
        name: '我的测评-提交测评',
        component: againAssess,
    },
    {
        path: '/:schoolcode(\\d+)/user/myAssess/endAssess',
        name: '我的测评-测评完成',
        component: endAssess,
    },
    // 2024-12-31 研学旅行下线
    // { path: "/:schoolcode(\\d+)?/yxlx", component: Study },
    {
        path: '/:school(\\d+)/hzvtc',
        name: '网上党校（党建思政教育资源平台）',
        component: HzvtcIndex,
    },
    { path: '/:school(\\d+)/hzvtc/culture', name: '党性修养-网上党校（党建思政教育资源平台）', component: HzvtcListCulture },
    { path: '/:school(\\d+)/hzvtc/hzdx', name: '杭职党校-网上党校（党建思政教育资源平台）', component: HzvtcListhzdx },
    { path: '/:school(\\d+)/hzvtc/profession', name: '职业素养-网上党校（党建思政教育资源平台）', component: HzvtcListProfession },
    { path: '/:school(\\d+)/hzvtc/value', name: '价值引领-网上党校（党建思政教育资源平台）', component: HzvtcListValue },
    { path: '/:school(\\d+)/hzvtc/feelings', name: '家国情怀-网上党校（党建思政教育资源平台）', component: HzvtcListFeelings },
    { path: '/:school(\\d+)/hzvtc/feature', name: '特色文化-网上党校（党建思政教育资源平台）', component: HzvtcListFeature },
    { path: '/:school(\\d+)/hzvtc/vita', name: '生命教育-网上党校（党建思政教育资源平台）', component: HzvtcListVita },
    { path: '/:school(\\d+)/hzvtc/detail', name: '网上党校（党建思政教育资源平台）', component: HzvtcDetail },
    { path: '/:school(\\d+)/hzvtc/newDetail', name: '杭职党校-网上党校（党建思政教育资源平台）', component: HzvtcnewDetail },
    { path: '/:school(\\d+)/hzvtc/search', name: '网上党校（党建思政教育资源平台）', component: HzvtcSearch },
    { path: '/:school(\\d+)/hzvtc/zyqsz', name: '专业群思政-网上党校（党建思政教育资源平台）', component: HzvtcZyqsz },
    { path: '/:school(\\d+)/hzvtc/article', name: '网上党校（党建思政教育资源平台）', component: HzvtcArticle },
    // custom开头的路由为院校单独定制且无需登录

    // 数字党建育人平台
    { path: '/:school(\\d+)/custom/party', name: '数字党建育人平台', component: PartyIndex },
    { path: '/:school(\\d+)/custom/party/list/join', name: '入党必备 - 数字党建育人平台', component: PartyJoin },
    { path: '/:school(\\d+)/custom/party/list/edu', name: '党性教育 - 数字党建育人平台', component: PartyEdu },
    { path: '/:school(\\d+)/custom/party/list/new', name: '新思想 新征程 - 数字党建育人平台', component: PartyNew },
    { path: '/:school(\\d+)/custom/party/list/learn', name: '四史领悟 - 数字党建育人平台', component: PartyLearn },
    { path: '/:school(\\d+)/custom/party/list/example', name: '榜样人物 - 数字党建育人平台', component: PartyExample },
    { path: '/:school(\\d+)/custom/party/list/local', name: '地方特色篇 - 数字党建育人平台', component: PartyLocal },
    { path: '/:school(\\d+)/custom/party/search', name: '数字党建育人平台', component: PartySearch },
    { path: '/:school(\\d+)/custom/party/detail', name: '数字党建育人平台', component: PartyDetail },
    { path: '/:school(\\d+)/custom/party/project', name: '数字党建育人平台', component: PartyProject },

    // 山西研学旅行
    { path: '/:school(\\d+)/custom/sxyxlx', name: '三晋纪胜 土木华章', component: sxyxlx },

    // 2024年农业智慧杯-朝阳区中小学生农业科普活动
    { path: '/:schoolcode(\\d+)/custom/clnyy', name: '智慧农业杯科普活动', component: clnyy },

    // 杭州科技职业技术学院-基地列表页、详情页 100060
    { path: '/:schoolcode(\\d+)/hangke/base', name: '实践基地-杭州市大中小学思政教育数字地图网络评审', component: BaseList },
    { path: '/:schoolcode(\\d+)/hangke/base/:classId', name: '实践基地-杭州市大中小学思政教育数字地图网络评审', component: BaseDetail },
    { path: '/:schoolcode(\\d+)/hangke/base/:classId/:videoId', name: '基地内容-杭州市大中小学思政教育数字地图网络评审', component: BaseVideo },
    // 黑龙江农业经济职业学院
    { path: '/:schoolcode(\\d+)/custom/hljdypx', name: '党员培训学习平台', component: hljindex },
    { path: '/:schoolcode(\\d+)/custom/hljdypx/pxztList', name: '党员培训学习平台', component: pxztList },
    { path: '/:schoolcode(\\d+)/custom/hljdypx/jjfzList', name: '党员培训学习平台', component: jjfzList },
    { path: '/:schoolcode(\\d+)/custom/hljdypx/hljDetail', name: '党员培训学习平台', component: hljDetail },

    // 教育在线k12资源资助项目-空页面，2026-09-03添加
    { path: '/:schoolcode(\\d+)/custom/qinghai', name: '教育在线k12资源资助项目', component: qinghai },
    {
        path: '*',
        name: '页面404',
        component: Page404,
    },
];

const newRoutes = [...staticRoutes];
let router = new VueRouter({
    mode: 'history',
    base: '/center/',
    routes: newRoutes,
});

router.beforeEach((to, from, next) => {
    // 杭职院logo修改
    var link = '';
    link = document.createElement('link');
    link.rel = 'icon';
    document.getElementsByTagName('head')[0].appendChild(link);
    if (to.path.indexOf('hzvtc') > -1) {
        link.href = 'https://hzvtc.jiaoyu.cn/app-assets/images/logo/logo40.png';
    } else {
        link.href = '../public/favicon.ico';
    }
    utils.setTitle(to.name);

    let code = utils.getUrlSchoolCode(window.location.pathname) || '';
    if (
        (!utils.whiteList.includes(to.path) && !(to.path.indexOf('hzvtc') > -1) && !(to.path.indexOf('/custom') > -1) && !(to.path.indexOf('/Page404') > -1)) ||
        to.path.indexOf('/custom/sxyxlx') > -1
    ) {
        if (to.path.indexOf('/nologin/') > -1) {
            next();
        } else {
            let appsToken = VueCookies.get('api_token');
            if (appsToken) {
                next();
            } else {
                if (code) {
                    window.open(`${services.APPS_SERVIER}/api/redirect?school_code=${code}&from=${encodeURIComponent(window.location.href)}`, '_self');
                } else {
                    // 未登录且 URL 不带学校 code（边缘情况）：放行到通配路由，渲染 404 页面
                    next();
                }
            }
        }
    } else {
        if (to.path.indexOf('hzvtc') > -1 && code != services.HZ_CODE) {
            window.open(`${services.XUEXI_HOST}/center/${services.HZ_CODE}/hzvtc`, '_self');
        } else if (to.path.indexOf('hljdypx') > -1 && code != services.HLJNY_CODE) {
            window.open(`${services.XUEXI_HOST}/center/${services.HLJNY_CODE}/custom/hljdypx`, '_self');
        } else {
            next();
        }
    }
});
router.beforeEach((to, from, next) => {
    document.body.scrollTop = 0;
    next();
});
export default router;
